import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Products
 * @type {function(type: string): {type: string, payload: any}}
 */
export const sportsGetRequest = simpleAction(TYPES.SPORTS_GET_REQUEST);

/**
 * Request sports success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const sportsGetSuccess = simpleAction(TYPES.SPORTS_GET_SUCCESS);

/**
 * Request sports error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const sportsGetError = simpleAction(TYPES.SPORTS_GET_FAIL);
